import React, { useEffect, useState, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, Label, Badge, Button } from "reactstrap";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import { getConsolidatorDataByRole, syncCnToBc } from "../../../../api";
// import { getFromLocalStorage } from "../../../hooks/useLocalStorage";
// import convertToRupees from "../../../utilities/convertToRupees";
import { getFromLocalStorage } from "../../../../hooks/useLocalStorage";
import convertToRupees from "../../../../utilities/convertToRupees";
import Breadcrumb from "../../../../layout/breadcrumb";
import Swal from "sweetalert2";

const CreditNoteListing = () => {
  const [gstSeries, setGstSeries] = useState("");
  const [gstError, setGstError] = useState("");
  const [isGstRegistered, setIsGstRegistered] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);

  // Terms modal toggle
  const toggleTermsModal = () => setTermsModalOpen(!termsModalOpen);
  // Terms modal agree
  const handleAgreeClick = () => {
    setTermsAccepted(true);
    toggleTermsModal();
  };

  // GST series generator
  const generateGstSeries = () => {
    const now = new Date();
    const year = now.getFullYear();
    const startYear = String(year).slice(-2);
    const endYear = String(year + 1).slice(-2);
    const prefix = "CPGC";
    const randomNum = Math.floor(1000 + Math.random() * 9000);
    return `${prefix}/${startYear}-${endYear}/${randomNum}`;
  };

  // Handle terms acceptance
  const handleTermsChange = (e) => {
    setTermsAccepted(e.target.checked);
  };

  const [creditNotes, setCreditNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [rowSelection, setRowSelection] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCreditNote, setSelectedCreditNote] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Fetch credit notes (CN-) only
  const fetchCreditNotes = async () => {
    setIsLoading(true);
    try {
      const roleId = getFromLocalStorage("user")?.consolidator_id;
      const res = await getConsolidatorDataByRole({ consolidator_id: roleId });
      console.log(res, "Credit Notes Response");
      // Extract document_ids from commission_request_data.documentTxnList for each CN
      const allData = res?.data?.result?.map(item => {
        const entry = item.commissionEntry;
        // Try to extract document_ids from commission_request_data.documentTxnList
        let document_ids = [];
        if (entry?.commission_request_data?.documentTxnList && Array.isArray(entry.commission_request_data.documentTxnList)) {
          document_ids = entry.commission_request_data.documentTxnList
            .map(txn => txn.document_id)
            .filter(Boolean);
        }
        return {
          commission_number: entry.commission_number,
          Tssign_No: entry.Tssign_No,
          amount: entry.total_commission_amount,
          payment_status: entry.payment_status,
          utr_number: entry.utr_number,
          document_ids: document_ids.length > 0 ? document_ids : undefined,
        };
      }) || [];
      // Only CN- entries
      const cnList = allData.filter(entry => String(entry.commission_number).startsWith('CN-'));
      setCreditNotes(cnList);
      setCount(cnList.length);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCreditNotes();
    // Check GST registration status from localStorage
    const user = getFromLocalStorage("user");
    if (typeof user?.is_gst_registered === "undefined" || user?.is_gst_registered === null) {
      setIsGstRegistered(false);
    } else {
      setIsGstRegistered(user?.is_gst_registered === true || user?.is_gst_registered === "yes");
    }
  }, []);

  const columns = useMemo(() => [
    {
      accessorKey: "commission_number",
      header: "Credit Note Number",
      enableSorting: true,
      Cell: ({ row }) => <span>{row.original.commission_number}</span>,
    },
    {
      accessorKey: "Tssign_No",
      header: "Tsign Number",
      enableSorting: false,
      Cell: ({ row }) => <span>{row.original.Tssign_No}</span>,
    },
    {
      accessorKey: "amount",
      header: "Credit Note Amount",
      enableSorting: false,
      Cell: ({ row }) => <span>{convertToRupees(row.original.amount)}</span>,
    },
    {
      accessorKey: "payment_status",
      header: "Status",
      enableSorting: false,
      Cell: ({ row }) => {
        const status = row.original.payment_status;
        console.log(status, "status in commission");
        let color = "success";
        let label = status;
        if (!status || status === "") {
          label = "Success";
          color = "success";
        } else if (status.toUpperCase() === "PAID") {
          label = "PAID";
          color = "success";
        } else if (status.toUpperCase() === "PROCESSING" || status.toUpperCase() === "PENDING") {
          label = status;
          color = "warning";
        } else if (status.toUpperCase() === "FAILED") {
          label = "FAILED";
          color = "danger";
        }
        return <Badge color={color}>{label}</Badge>;
      },
    },
    {
      accessorKey: "utr_number",
      header: "PI/UTR Number",
      enableSorting: false,
      Cell: ({ row }) => <span>{row.original.utr_number || ''}</span>,
    },
  ], []);

  // Claim handler opens modal for selected credit note(s)
  const handleClaim = () => {
    const selectedIds = Object.keys(rowSelection);
    if (selectedIds.length === 0) return;
    // Only show first selected for modal details
    setSelectedCreditNote(creditNotes.find(c => c.commission_number === selectedIds[0]));
    setModalOpen(true);
    setGstSeries("");
    setGstError("");
    setTermsAccepted(false);
    setSubmitting(false);
  };

  // Submit handler (dummy, replace with actual API if needed)
  const handleSubmitClaim = async () => {
    if (!termsAccepted) {
      setGstError("");
      Swal.fire({
        icon: 'warning',
        title: 'Terms Required',
        text: "Please accept the terms and conditions."
      });
      return;
    }
    setSubmitting(true);
    try {
      // Build payload for syncCnToBc
      const selectedIds = Object.keys(rowSelection);
      if (selectedIds.length === 0) {
        setSubmitting(false);
        return;
      }
      const cn = creditNotes.find(c => c.commission_number === selectedIds[0]);
      if (!cn) {
        setSubmitting(false);
        return;
      }
      // GST series logic
      let gstValue;
      if (isGstRegistered) {
        gstValue = "GSTIN-REGISTERED";
      } else {
        gstValue = gstSeries;
        if (!gstValue) {
          gstValue = generateGstSeries();
          setGstSeries(gstValue);
        }
      }
      // Prepare payload
      const user = getFromLocalStorage("user");
      const activeConsolidator = {
        consolidator_id: user?.consolidator_id,
        code: user?.code || "",
      };
      // Use document_ids from CN (extracted from backend)
      let document_ids = cn.document_ids;
      if (!document_ids || (Array.isArray(document_ids) && document_ids.length === 0)) {
        document_ids = [cn.commission_number];
      }
      // invoice_ids as array
      let invoice_ids = Array.isArray(document_ids) ? document_ids : [document_ids];
      // documentTxnList as array of objects with document_id
      let docIdArr = typeof document_ids === "string" ? document_ids.split(",").map(id => id.trim()).filter(Boolean) : (Array.isArray(document_ids) ? document_ids : [document_ids]);
      const documentTxnList = docIdArr.map(docId => ({
        document_id: docId,
        partnership_id: "",
        commissionAmount: cn.amount,
        gstAmount: 0,
        tdsAmount: 0,
        documentCode: docId,
      }));
      const cnCommissionEntry = {
        commission_unique_id: cn.commission_number, // Should be actual unique id
        commission_number: cn.commission_number,
        Tssign_No: cn.Tssign_No,
        invoice_ids,
        gst_series: gstValue,
        commission_request_data: {
          documentTxnList
        }
      };
      const payload = { cnCommissionEntry, activeConsolidator };
      const result = await syncCnToBc(payload);
      console.log("Sync result:CN", result);
      if(result.data.result[0].syncToBc.statusCode < 400) {
        setSubmitting(false);
        setModalOpen(false);
        Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Your Credit Note has been successfully claimed.',
        });
        // Refresh the listing after successful claim
        fetchCreditNotes();
      } else {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Credit Note has already been processed. Please check later.'
        });
        setModalOpen(false);
        setSubmitting(false);
      }
    } catch (error) {
      setSubmitting(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error?.response?.data?.error || "Failed to sync credit note. Please try again."
      });
    }
  };

  return (
    <React.Fragment>
      <Breadcrumb parent="Sales" title="Credit Note" />
      <div>
        <MaterialReactTable
          columns={columns}
          data={creditNotes}
          enableGlobalFilter={false}
          initialState={{ showColumnFilters: false, density: "compact" }}
          positionToolbarAlertBanner="bottom"
          defaultColumn={{ maxSize: 400, minSize: 80, size: 100 }}
          rowCount={count}
          state={{ isLoading, rowSelection }}
          manualPagination
          enableMultiRowSelection={true}
          enableRowSelection={
            (row) => {
              console.log(row, "status in row selection")
              return (row.original.payment_status?.toUpperCase() === "PENDING")
            }
          }
          // enableRowSelection={(row) => row.original.payment_status?.toUpperCase() !== "PENDING"}
          getRowId={(row) => row.commission_number}
          onRowSelectionChange={setRowSelection}
          muiTableBodyRowProps={({ row }) => ({
            onClick: row.getToggleSelectedHandler(),
            sx: { cursor: 'pointer' },
          })}
          renderTopToolbarCustomActions={({ table }) => (
            <Box sx={{ display: "flex", gap: "0.3rem", p: "0.5rem", flexWrap: "wrap" }}>
              <Button
                color="primary"
                size="sm"
                className="btnCustom"
                variant="contained"
                onClick={handleClaim}
                disabled={Object.keys(rowSelection).length === 0}
              >
                <i className="fa fa-plus"></i> Raise
              </Button>
              <Button
                color="primary"
                size="sm"
                className="btnCustom text-white"
                variant="outlined"
                onClick={fetchCreditNotes}
                style={{ marginLeft: 4, borderColor: '#800080', color: '#800080' }}
              >
                <i className="fa fa-refresh"></i> Refresh
              </Button>
              <Badge color="success">
                Selected : {Object.keys(rowSelection).length}
              </Badge>
            </Box>
          )}
        />
      </div>

      {/* Claim Modal */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Raise Credit Note
        </ModalHeader>
        <ModalBody>
          {selectedCreditNote && (
            <>
              <div style={{ marginBottom: 16 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                  <thead style={{ background: '#f2f2f2' }}>
                    <tr>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Credit Note Number</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Credit Note Amount</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{selectedCreditNote.commission_number}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{convertToRupees(selectedCreditNote.amount)}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{selectedCreditNote.payment_status || ''}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <FormGroup>
                <Label for="gst-series">
                  GST Series
                </Label>
                <Input
                  id="gst-series"
                  type="text"
                  value={(() => {
                    if (isGstRegistered) {
                      return "GSTIN-REGISTERED";
                    } else {
                      if (!gstSeries) {
                        const now = new Date();
                        const year = now.getFullYear();
                        const startYear = String(year).slice(-2);
                        const endYear = String(year + 1).slice(-2);
                        const prefix = "CPGC";
                        const randomNum = Math.floor(1000 + Math.random() * 9000);
                        setGstSeries(`${prefix}/${startYear}-${endYear}/${randomNum}`);
                        return `${prefix}/${startYear}-${endYear}/${randomNum}`;
                      }
                      return gstSeries;
                    }
                  })()}
                  disabled
                  readOnly
                />
                <div style={{ fontSize: '12px', color: '#888', marginTop: 4 }}>
                  GST Series is auto-generated and cannot be edited.
                </div>
              </FormGroup>
              <FormGroup check style={{ marginTop: 16 }}>
                <Input type="checkbox" id="terms" checked={termsAccepted} onChange={handleTermsChange} />
                <Label for="terms" check>
                  I accept the <a
                    href="#"
                    onClick={e => { e.preventDefault(); toggleTermsModal(); }}
                    style={{ color: '#007bff', textDecoration: 'underline' }}
                  >terms & conditions</a>.
                </Label>
              </FormGroup>
              {/* Terms and Conditions Modal */}
              <Modal isOpen={termsModalOpen} toggle={toggleTermsModal} size="lg">
                <ModalHeader toggle={toggleTermsModal}>Terms and Conditions</ModalHeader>
                <ModalBody style={{ maxHeight: '400px', overflowY: 'auto', scrollbarWidth: "none", msOverflowStyle: "none" }}>
                  <p>I hereby agree that I am the Authorized Signatory of Proprietorship / Partnership Firm / Company/ LLP (hereinafter referred as "Entity") duly authorized to digitally sign the invoices, and receive One Time Password (OTP) on my registered mobile number for business purpose on behalf of the said Entity. I hereby provide my consent for the above and to receive OTP on the said number to authenticate details on behalf of the Entity. I understand and agree that the OTP provided herein;</p>
                  <p>- shall be used only for the purpose of authenticating the identity of the Authorized Signatory on behalf of the said Entity through the Mobile based OTP system.,</p>
                  <p>- shall be used to avail my consent for digitally signing the invoices (using my Digital Signature) specific under this Travel Care  / Paperless arrangement with Europ Assistance India Private Limited ("EAI") and not for any other purpose otherwise.</p>
                  <p>I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it. I hereby authorize sharing of the information furnished herewith to be used for business purpose agreed herein.</p>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={toggleTermsModal}>Close</Button>
                  <Button color="primary" onClick={handleAgreeClick}>I Agree</Button>
                </ModalFooter>
              </Modal>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmitClaim} disabled={submitting}>
            {submitting ? "Raising..." : "Raise"}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default CreditNoteListing;
